module.exports = __webpack_public_path__ + "static/media/conf-app1.b8682bf8.png";